import api from '@api'
import {
  transformRemoteOffice,
  transformRemoteOfficeForServer,
} from '@data/remote-office'
import {
  buildRelationalQualificationStructure,
  buildFlatQualificationStructure,
  buildNameFilterQuery,
} from '@data/qualification'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

const buildQualifications = (qualificationFactors) => {
  const quals = []
  if (qualificationFactors.name) {
    quals.push(buildNameFilterQuery(qualificationFactors.name))
  }
  if (
    qualificationFactors.selectedName &&
    qualificationFactors.selectedName.length
  ) {
    quals.push(buildNameFilterQuery(qualificationFactors.selectedName, 'in'))
  }
  if (qualificationFactors.ids) {
    quals.push(
      buildRelationalQualificationStructure(
        'id',
        'in',
        qualificationFactors.ids,
        'long',
        'db'
      )
    )
  }
  if (qualificationFactors.excludedIds) {
    quals.push(
      buildRelationalQualificationStructure(
        'id',
        'not_in',
        qualificationFactors.excludedIds,
        'long',
        'db'
      )
    )
  }
  return buildFlatQualificationStructure(quals)
}
export function getRemoteOfficesApi(
  filter,
  limit,
  offset,
  additionalParams = {}
) {
  return api
    .post(
      `/remoteoffice/search/byqual`,
      {
        qualDetails:
          filter.name || filter.ids || filter.excludedIds || filter.selectedName
            ? buildQualifications(filter)
            : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...additionalParams,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformRemoteOffice) || [],
        total: data.totalCount,
      }
    })
}
export function updateRemoteOfficesApi(data) {
  return api
    .patch(`/remoteoffice/${data.id}`, transformRemoteOfficeForServer(data), {
      message: __rootT('updated_successfully', {
        resource: __rootTc('remote_office'),
      }),
    })
    .then(transformRemoteOffice)
}

export function createRemoteOfficeApi(data) {
  return api
    .post(`/remoteoffice`, transformRemoteOfficeForServer(data), {
      message: __rootT('created_successfully', {
        resource: __rootTc('remote_office'),
      }),
    })
    .then(transformRemoteOffice)
}

export function deleteRemoteOfficeApi(id) {
  return api.delete(`/remoteoffice/${id}`, {
    message: __rootT('deleted_successfully', {
      resource: __rootTc('remote_office'),
    }),
  })
}
